import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../auth/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() hq = false;
  header = 'In-store Communication';
  hqHeader = 'ISC HQ';
  homeUrl = '/store';

  constructor(public authenticationService: AuthenticationService) { }

  ngOnInit() {
    if (this.hq) {
      this.header = this.hqHeader;
      this.homeUrl = '/hq';
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/header/header.component.ts